import { List, styled, Typography } from '@mui/material';
import { Work } from '@mui/icons-material';
import SearchResultItem from './SearchResultItem';
import { Row } from 'components/Layout';
import { useHistory } from 'react-router-dom';
import { LatestSearch } from './useGlobalSearch';

const ResultsList = styled(List)({
  margin: 0,
  padding: 0,
});

type Props = {
  latestSearched: Array<LatestSearch>;
};

const LatestSearched: React.FC<Props> = ({ latestSearched }) => {
  const history = useHistory();

  return (
    <ResultsList>
      {latestSearched.map((result) => (
        <SearchResultItem
          key={result.url}
          id={result.url}
          name={result.name}
          logo={result.logo}
          onClick={(url) => {
            history.push(url);
          }}
        >
          <Row spacing="xs" centered>
            <Typography variant="body2">in:</Typography>
            <Work fontSize="small" />
            <Typography variant="h6" color="grey.600">
              Companies
            </Typography>
          </Row>
        </SearchResultItem>
      ))}
    </ResultsList>
  );
};

export default LatestSearched;
